export const SERVICE_TYPES: any = {
	all: '',
	service: 1,
	integration: 4
};
